export enum Semester {
	Spring = 'spring',
	Fall = 'fall',
}